import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import HeroCarousel from "./components/HeroCarousel";
import NewsDigest from "./components/NewsDigest";
import FeaturedAnime from "./components/FeaturedAnime";
import TopicSection from "./components/TopicSection";
import AboutIntro from "./components/AboutIntro";
import Sidebar from "./components/Sidebar";

export default function Home() {
  useDocumentMeta(
    "h动漫—最新动漫资讯与作品推荐平台",
    "h动漫提供丰富的动漫资讯、作品介绍及评论分析，覆盖多类型动漫内容，满足动漫爱好者的多元需求。"
  );

  return (
    <div className="w-full px-4 md:px-6 py-6 md:py-8">
      <h1 className="sr-only">h动漫 - 最新动漫资讯与作品</h1>
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-6 md:gap-8">
        <div className="min-w-0 space-y-6 md:space-y-10">
          <HeroCarousel />
          <div className="lg:hidden">
            <Sidebar />
          </div>
          <NewsDigest />
          <FeaturedAnime />
          <TopicSection />
          <AboutIntro />
        </div>
        <div className="hidden lg:block">
          <Sidebar />
        </div>
      </div>
    </div>
  );
}